import { getAgreements } from "@/Services/TherapyApi/LegalAgreements";

import useLegalAgreementStore from "@/Modules/LegalAgreement/Store";

async function getUserLegalAgreementsAH(customerId: string, userId: string | undefined) {
  const legalAgreementStore = useLegalAgreementStore();

  legalAgreementStore.legalAgreements = await getAgreements(customerId, userId);
}

export default getUserLegalAgreementsAH;
